module.exports = __webpack_public_path__ + "img/35.8152639d.png";